module.exports = __webpack_public_path__ + "node_modules/icheck/skins/flat/yellow.png?b80c9cf4";